import * as React from 'react';

export const PendingAccount = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <h1 className="text-4xl font-bold mb-4">Pending Account</h1>
      <p className="text-gray-600 text-lg mb-44">
        This page belongs to a customer with a pending account. Only customers who have completed
        checkout in the funnel can be viewed in BARK.
      </p>
    </div>
  );
};
